import type { ReactElement } from 'react'

import { TagBadge } from '~/components/Badges'
import Tooltip from '~/components/Tooltip'

interface Props {
  infos: string[]
  title: string
}

const MAX_TAGS_ITEM = 5

const PageContainerInfo = ({ infos, title }: Props): ReactElement => {
  return (
    <div className="page-container-details-header__info">
      <span className="page-container-details-header__info__title">{title}:</span>
      <div className="page-container-details-header__info__items">
        {infos.slice(0, MAX_TAGS_ITEM).map((requirement, i) => (
          <TagBadge className="requirement-badge" key={`${infos}-${i}`} size="medium" value={requirement} />
        ))}
        {infos.length > MAX_TAGS_ITEM ? (
          <Tooltip
            align={{ points: ['br', 'tr'] }}
            overlay={
              <div className="page-container-tooltips-content">
                {infos.slice(MAX_TAGS_ITEM).map((requirement, i) => (
                  <TagBadge
                    className="requirement-badge badge"
                    key={`tooltip-${infos}-${i}`}
                    size="medium"
                    value={requirement}
                  />
                ))}
              </div>
            }
            placement="top"
            trigger="hover"
          >
            <div className="counter">+{infos.length - MAX_TAGS_ITEM}</div>
          </Tooltip>
        ) : null}
      </div>
    </div>
  )
}

export default PageContainerInfo
